import { Transform } from 'class-transformer';
export const TransformBoolean = () => {
    return Transform(({ obj, key }) => obj[key].toLowerCase() === 'true');
};
